import { AnswerType } from '@app-studio-web/ui/types'
import QuizMultiChoicePage from './QuizMultiChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '😘',
    title: 'pages.quizOnboarding.topics.answer1',
    value: 'flirting_dating',
  },
  { emoji: '🤣', title: 'pages.quizOnboarding.topics.answer2', value: 'slang' },
  {
    emoji: '🎙️',
    title: 'pages.quizOnboarding.topics.answer3',
    value: 'pronunciation',
  },
  {
    emoji: '🙋',
    title: 'pages.quizOnboarding.topics.answer4',
    value: 'asking_questions',
  },
  {
    emoji: '✈️',
    title: 'pages.quizOnboarding.topics.answer5',
    value: 'travel',
  },
  {
    emoji: '💼',
    title: 'pages.quizOnboarding.topics.answer6',
    value: 'work_business',
  },
  {
    emoji: '🙅',
    title: 'pages.quizOnboarding.topics.answer7',
    value: 'common_mistakes',
  },
  {
    emoji: '👫',
    title: 'pages.quizOnboarding.topics.answer8',
    value: 'friends_family',
  },
  {
    emoji: '🏋️',
    title: 'pages.quizOnboarding.topics.answer9',
    value: 'health_fitness',
  },
  {
    emoji: '🍔',
    title: 'pages.quizOnboarding.topics.answer10',
    value: 'food_drinks',
  },
]

export default function TopicsPage() {
  return (
    <QuizMultiChoicePage
      answers={answers}
      maxSelections={3}
      subtitle="pages.quizOnboarding.topics.subtitle"
      title="pages.quizOnboarding.topics.title"
    />
  )
}
